exports.languages = {
  en: 'en',
  us: 'en-us',
  za: 'en-za',
  zh: 'zh-hans',
  ja: 'ja',
  ko: 'ko',
  es: 'es',
};

exports.menus = {
  en: 'header-gb',
  us: 'header-us',
  za: 'header-sa',
  zh: 'header-cn',
  ja: 'header-ja',
  ko: 'header-ko',
  es: 'header-es',
};
